module.exports = __webpack_public_path__ + "static/media/fora_cerca.8543fea4.svg";